import './styles.css';

import { MotionProvider, ThemeProvider, Toaster, TooltipProvider } from '@glory/ui';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { z } from 'zod';

import { FeedbackWidget } from './features/feedback/feedback-widget.tsx';
import { queryClient, router } from './router.tsx';

// Сообщения проверок Zod в формах — по-русски.
z.config(z.locales.ru());

// Service worker: push при закрытой вкладке. Регистрируется после загрузки, чтобы не мешать первому экрану.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js');
  });
}

const root = document.getElementById('root');
if (!root) throw new Error('Нет элемента #root');

createRoot(root).render(
  <StrictMode>
    <ThemeProvider>
      <MotionProvider>
        <TooltipProvider>
          <QueryClientProvider client={queryClient}>
            <RouterProvider router={router} />
          </QueryClientProvider>
          <Toaster />
          <FeedbackWidget />
        </TooltipProvider>
      </MotionProvider>
    </ThemeProvider>
  </StrictMode>,
);
